export default __webpack_public_path__ + "locales/bg/Payments.json?hash=24b3eb667ce8243efdf0f7cf486f8fa5";